import { AbstractMigrateResourceCommand, Topics } from '@zaplify/common';

export class MigrateProspectsCommand extends AbstractMigrateResourceCommand {
    public static override readonly TOPIC: Topics = Topics.PROSPECTS;
}
